module.exports = __webpack_public_path__ + "img/ic-tick-circle-green.2ca10b7a.svg";